import { render } from "./PriceDecreaseTable.vue?vue&type=template&id=ac6400d2&scoped=true"
import script from "./PriceDecreaseTable.vue?vue&type=script&lang=js"
export * from "./PriceDecreaseTable.vue?vue&type=script&lang=js"

import "./PriceDecreaseTable.vue?vue&type=style&index=0&id=ac6400d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac6400d2"]])

export default __exports__